export const ORDER_PARTNERS_PACKAGES = {
  MUTATIONS: {
    SET_LIST: 'order-partners-packages-set-list',
    SET_ACTIVE_ID: 'order-partners-packages-set-active',
    SET_ADDRESS: 'order-partners-packages-set-address'
  },
  ACTIONS: {
    INIT_LIST: 'order-partners-packages-init-list'
  },
  GETTERS: {
    LIST: 'order-partners-packages-get-list',
    ACTIVE_ID: 'order-partners-packages-get-active',
    INCLUDED_ITEM: 'order-partners-packages-get-included-item',
    ADDRESS: 'order-partners-packages-get-address'
  }
}
